module.exports = __webpack_public_path__ + "static/media/Kelloggs All Bran Mechanic.7ce3fb30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Kelloggs All Bran Mechanic.jpg
// module id = 182
// module chunks = 0